import GetStartedCenter from './GetStartedCenter';

export default GetStartedCenter;
